const formatRelativeTime = (input) => {
    if (!input) return "";

    const date = input instanceof Date ? input : new Date(input);

    if (isNaN(date.getTime())) return "";

    const now = new Date();
    const diffMs = now - date;

    const minute = 60 * 1000;
    const hour   = 60 * minute;
    const day    = 24 * hour;
    const week   = 7 * day;
    const month  = 30 * day;
    const year   = 365 * day;

    if (diffMs >= year) {
        const years = Math.floor(diffMs / year);
        return `${years} year${years > 1 ? "s" : ""} ago`;
    }

    if (diffMs >= month) {
        const months = Math.floor(diffMs / month);
        return `${months} month${months > 1 ? "s" : ""} ago`;
    }

    if (diffMs >= week) {
        const weeks = Math.floor(diffMs / week);
        return `${weeks} week${weeks > 1 ? "s" : ""} ago`;
    }

    if (diffMs >= day) {
        const days = Math.floor(diffMs / day);
        return `${days} day${days > 1 ? "s" : ""} ago`;
    }

    if (diffMs >= hour) {
        const hours = Math.floor(diffMs / hour);
        return `${hours} hour${hours > 1 ? "s" : ""} ago`;
    }

    if (diffMs >= minute) {
        const minutes = Math.floor(diffMs / minute);
        return `${minutes} min ago`;
    }

    return "Just now";
};

export default formatRelativeTime;
